import React from "react";
import { StarIcon, UserIcon } from "lucide-react";
import { testimonials } from "../data/content";
import { useLazyBackground } from "../hooks/useLazyBackground";
export function Testimonials() {
  const bg = useLazyBackground<HTMLElement>("https://cdn.magicpatterns.com/uploads/tTLxF1xvK7X1GDZ2MpibP3/\u043A\u043B\u0438\u043D\u0438\u043D\u0433.jpg");
  return <section ref={bg.ref} className="bg-paper py-20 md:py-28" aria-labelledby="testimonials-title" style={{
    backgroundImage: bg.backgroundImage,
    backgroundSize: "auto",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat"
  }} data-id="element-218" data-mp="36yzeknasv4mw">
      <div className="mx-auto max-w-6xl px-5 md:px-8" data-id="element-219" data-mp="2x007h95onh20">
        <h2 id="testimonials-title" className="max-w-xl font-display text-3xl font-semibold leading-tight text-ink md:text-[2.75rem]" data-id="element-220" data-mp="2x2mmftuwkyu9">
          Tu próximo paso puede empezar hoy.
        </h2>

        <div className="mt-12 grid gap-5 md:grid-cols-3" data-id="element-221" data-mp="v72ijof118mc">
          {testimonials.map((t, i) => <figure key={i} className="flex flex-col rounded-3xl bg-white p-7 ring-1 ring-line" data-id="element-222" data-mp="qb54xpv5egd9" data-mpi={i}>
              <div className="flex gap-0.5" role="img" aria-label="5 de 5 estrellas" data-id="element-223" data-mp="h4n44cnfo1bg">
                {Array.from({
              length: 5
            }).map((_, s) => <StarIcon key={s} className="h-4 w-4 fill-sun text-sun" aria-hidden="true" data-id="element-224" data-mp="78aepqyx89mi" data-mpi={s} />)}
              </div>
              <blockquote className="mt-5 flex-1 font-display text-lg leading-relaxed text-ink" data-id="element-225" data-mp="c7wp7snd7brm">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-6 flex items-center gap-3 border-t border-line pt-5" data-id="element-226" data-mp="zyseoj4cluvp">
                <span className="flex h-11 w-11 items-center justify-center rounded-full bg-mint text-ink" data-id="element-227" data-mp="14xdeihfoucjm">
                  <UserIcon className="h-5 w-5" aria-hidden="true" data-id="element-228" data-mp="v5ptay9q5rql" />
                </span>
                <span data-id="element-229" data-mp="v3d2dvlzo71e">
                  <span className="block font-bold text-ink" data-id="element-230" data-mp="1ivk0p0b9yo3g">{t.name}</span>
                  <span className="block text-sm text-muted" data-id="element-231" data-mp="1ith39v7slsop">{t.detail}</span>
                </span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}